<template>
  <div>
    <div
      class="blurb-and-subscription-container w-100"
      :class="$vuetify.breakpoint.width <= 1280 ? '' : 'py-5'"
    >
      <div class="blurb-and-subscription">
        <div
          class="display-flex align-center justify-space-between gap-8"
          :class="$vuetify.breakpoint.width <= 1280 ? 'flex-column' : ''"
        >
          <div class="blurb-container">
            <div
              class="font-space-grotesk font-weight-500"
              :class="$vuetify.breakpoint.width <= 1280 ? 'text-32 text-center display-flex white--text font-weight-700' : 'text-50 white--text'"
            >
              <span v-if="$vuetify.breakpoint.width > 1280">Streaming Revenue<br />Estimator</span>
              <span v-else>Estimate Streaming Revenue</span>
            </div>

            <!--
            <button
              v-if="$vuetify.breakpoint.width > 1280"
              class="btn-create-account"
              @click="$router.push({ path: '/signup' })"
            >
              Create account
            </button>
            -->

          </div>
          <div class="subscription-container">
            <div
              class="subscription-plan"
              :class="{ 'bg-white': $vuetify.breakpoint.width > 1280 }"
            >
              <div class="text-center overflow-hidden font-space-grotesk">
                <div class="pa-7">
                  <div class="title-money">{{ formattedListenerCount }}</div>

                  <div class="font-weight-bold title-money-note text-14 pt-2">
                    Monthly listeners
                  </div>

                  <div class="slider-component">
                    <div class="slide-container">
                      <input
                        ref="input"
                        v-model="formData.range"
                        type="range"
                        :min="0"
                        :max="increments.length - 1"
                        class="slider"
                        @input="updateRangePrice"
                      />
                    </div>
                  </div>
                </div>

                <div class="revenue-output-box">
                  <div class="result-price">{{ youSoundRevenue }}</div>
                  <div class="result-price-text">YOUSOUND</div>
                </div>
                <div class="revenue-output-box">
                  <div class="result-price">{{ dspRevenue }}</div>
                  <div class="result-price-text">OTHER MUSIC PLATFORMS</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Footer button for mobile -->
    <div
      v-if="$vuetify.breakpoint.width <= 1280"
      class="btn-wrapper"
    >
      <button class="btn-sign-up" @click="redirectToAppStore">
        Sign up
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "RevenueCalculator",
  data() {
    return {
      formData: {
        range: 0,
      },
      increments: [
        0, 50, 100, 500, 1000, 2500, 5000, 10000, 25000, 35000, 50000, 100000,
        150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 550000,
        1000000, 2000000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000,
        9000000, 10000000, 20000000, 30000000, 40000000, 50000000, 60000000,
        70000000, 80000000, 90000000, 100000000, 110000000, 120000000,
        130000000, 140000000, 150000000,
      ],
      youSoundRevenue: "",
      dspRevenue: "0",
      listenerCount: 0,
    };
  },
  mounted() {
    this.updateRangePrice();
  },
  methods: {
    updateRangePrice() {
      const selectedValue = this.increments[this.formData.range];
      this.listenerCount = selectedValue;

      const totalStreams = selectedValue * 4; // High STL ratio for DSP calculation
      const dspRate = 0.003; // $0.003 per stream on DSPs
      const dspTotalRevenue = totalStreams * dspRate;

      const youSoundRateMin = 0.5; // $0.50 per listener
      const youSoundRateMax = 5.0; // $5.00 per listener

      // Calculate the YouSound revenue range
      const youSoundLowRatio = 1.0; // Use 100% of listeners for low STL ratio
      const youSoundHighRatio = 1.0; // High STL ratio (100% of listeners)

      const youSoundRevenueLow =
        selectedValue * youSoundLowRatio * youSoundRateMin;
      const youSoundRevenueHigh =
        selectedValue * youSoundHighRatio * youSoundRateMax;

      this.dspRevenue = `$${this.formatNumber(Math.round(dspTotalRevenue))}`;

      if (selectedValue === 0) {
        this.youSoundRevenue = "$0";
      } else {
        this.youSoundRevenue = `$${this.formatNumber(
          Math.round(youSoundRevenueLow)
        )} - $${this.formatNumber(Math.round(youSoundRevenueHigh))}`;
      }
    },
    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(0) + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(0) + "K";
      }
      return num.toString();
    },
    redirectToAppStore() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.example.android"; // Replace with your Android app link
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = "https://apps.apple.com/us/app/yousound/id1452078262"; // Replace with your iOS app link
      } else {
        window.location.href = "/signup"; // Fallback for web browsers
      }
    },
  },
  computed: {
    formattedListenerCount() {
      return this.formatNumber(this.listenerCount);
    },
  },
};
</script>



<style lang="scss" scoped>
/* Common Styles */
.line {
  height: 1px;
  margin-top: 40px;
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.blurb-container {
  margin-top: -40px;
}

.title-money {
  color: rgba(0, 0, 0, 1);
  font-family: Space Grotesk;
  font-size: 2.25rem; /* 36px */
  font-weight: 700;
  line-height: 2.335rem; /* 37.36px */
  text-align: center;
}

.title-money-note {
  font-family: Inter;
  font-size: 0.875rem; /* 14px */
  font-weight: 700;
  line-height: 0.91rem; /* 14.53px */
  text-align: center;
  text-transform: uppercase;
  margin-top: 0;
}

.btn-create-account {
  width: 230px;
  height: 60px;
  font-family: Inter;
  font-size: 1.25rem; /* 20px */
  font-weight: 700;
  line-height: 1.555rem; /* 24.91px */
  text-align: center;
  background: white;
  border-radius: 56px;
  margin-top: 50px;
}

.subscription-plan {
  border-radius: 40px !important;
  padding: 40px !important;
  margin: 12px !important;
}

.slider-component .slide-container {
  padding-top: 40px;
  padding-bottom: 25px;
  width: 100%;
  will-change: transform;
}

.slider-component .slide-container .slider {
  appearance: none;
  width: 100%;
  height: 2px;
  border-radius: 7px;
  outline: none;
  transition: opacity 0.2s;
  background: rgba(0, 0, 0, 0.14);
  will-change: transform;
  transform: translateZ(0);
}

.slider-component .slide-container .slider:hover {
  opacity: 1;
}

.slider-component .slide-container .slider::-webkit-slider-thumb {
  appearance: none;
  width: 31px;
  height: 31px;
  background: #000;
  cursor: pointer;
  border-radius: 50%;
}

.slider-component .slide-container .slider::-moz-range-thumb {
  appearance: none;
  width: 31px;
  height: 31px;
  background: #000;
  cursor: pointer;
  border-radius: 50%;
}

.revenue-output-box {
  width: 100%;
  border-radius: 16px;
  margin-top: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.result-price {
  font-family: Space Grotesk;
  font-size: 2.25rem; /* 36px */
  font-weight: 700;
  line-height: 2.335rem; /* 37.36px */
  letter-spacing: -0.02em;
  text-align: center;
  margin-bottom: 10px; /* Add space within the box */
}

.result-price-text {
  font-family: Inter;
  font-size: 0.875rem; /* 14px */
  font-weight: 700;
  line-height: 0.91rem; /* 14.53px */
  text-align: center;
}

@media screen and (max-width: 1280px) {
  .subscription-plan {
    border: none !important;
  }

  .text-estimate {
    color: #000;
    font-size: 1.75rem; /* 28px */
    line-height: 2rem; /* 32px */
    text-align: center;
  }

  .title-money {
    color: #fff;
  }

  .title-money-note {
    color: #fff;
  }

  .revenue-output-box {
    background-color: rgba(0, 0, 0, 0.08); /* Add opacity */
  }

  .result-price {
    color: #fff;
    font-size: 2rem; /* 32px */
    font-weight: 700;
    line-height: 2.335rem; /* 37.36px */
    margin-bottom: 10px; /* Add space within the box */
  }

  .result-price-text {
    color: #fff;
    font-size: 0.875rem; /* 14px */
  }

  .sign-up-text {
    font-family: Inter;
    font-size: 1.25rem; /* 20px */
    font-weight: 700;
    line-height: 1.2975rem; /* 20.76px */
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }

  .slider-component .slide-container .slider {
    background: rgba(255, 255, 255, 0.2);
    will-change: transform;
    transform: translateZ(0);
  }

  .slider-component .slide-container .slider::-webkit-slider-thumb {
    background: #fff;
  }

  .slider-component .slide-container .slider::-moz-range-thumb {
    background: #fff;
  }

  .btn-wrapper {
    position: fixed;
    bottom: 0;
    background: fff0;
    z-index: 1;
    padding: 20px 12px;
    gap: 4px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .btn-sign-up {
    font-family: Outfit;
    font-size: 1.375rem; /* 22px */
    font-weight: 500;
    text-align: center;
    height: 60px;
    padding: 0 24px;
    border-radius: 56px;
    min-width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 24px);
    letter-spacing: -.5px;
    background: #fff;
    color: #000;
    max-width: 400px;
  }

  .information {
    font-family: Outfit;
    font-size: 2.125rem; /* 34px */
    font-weight: 700;
    line-height: 2.625rem; /* 42px */
    text-align: left;
    max-width: 450px;
    text-align: center;
    margin: 0 auto;
  }

  .sp-btn-revenue-calculator {
    font-family: Inter;
    font-size: 1.25rem; /* 20px */
    font-weight: 700;
    line-height: 1.2975rem; /* 20.76px */
    text-align: center;
    color: rgba(0, 0, 0, 1);
    background-color: #fff;
    border-radius: 123px;
    width: 100%;
    height: 50px;
  }

  .btn-wrapper {
    position: fixed;
    bottom: 0;
    background: fff0;
    z-index: 1;
    padding: 30px 12px;
    gap: 4px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center; /* Center the buttons */
  }

  .btn-try-calculator,
  .btn-sign-up {
    font-family: Outfit;
    font-size: 1.25rem; /* 20px */
    font-weight: 600;
    text-align: center;
    height: 50px;
    padding: 0 24px;
    border-radius: 56px;
    min-width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: -0.5px;
    margin: 0 10px; /* Add margin between the buttons */
  }

  .btn-try-calculator {
    background: #fff;
  }

  .btn-sign-up {
    background: #fff;
    color: #000;
  }

  .text-32 {
    font-size: 1.75rem; /* 28px */
    line-height: 2.25rem; /* 36px */
    font-weight: 600;
    margin-top: 14px;
    margin-bottom: 0px;
  }

  .sp-text {
    margin-top: -200px;
    padding: 200px 20px;
  }
}

/* Desktop-specific overrides */
@media screen and (min-width: 1281px) {
  .revenue-output-box {
    background-color: transparent; /* or background-color: white; */
  }

  .result-price {
    color: black; /* Ensure text is black for better visibility */
  }

  .font-weight-500 {
    font-weight: 700;
  }

  .result-price-text {
    color: black; /* Ensure text is black for better visibility */
  }
}

</style>



// WEBPACK FOOTER //
// RevenueCalculator.vue?4878e7fb